import Filter from "./features/Filter";
import List from "./features/List";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { pcsListMapInit, pcsSearchParamInit } from "./state";
import { PcsSearchParamType } from "./interface";
import { useReadPurchaseOrderList } from "./hooks/useReadPurchaseOrderList";
import { useUser } from "../../../../util/userContext/UserContext";
import { useReadDeliveryList } from "./hooks/useReadDeliveryList";
import moment from "moment/moment";
import { set } from "react-hook-form";

export default function PcsList({ isOrderRequest, isPcsDelivery }: {
    isOrderRequest?: boolean,
    isPcsDelivery?: boolean,
}) {
    const { user } = useUser()

    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const [searchParam, setSearchParam] = useState<PcsSearchParamType>((() => ({
        ...pcsSearchParamInit,
        toDate: moment().add(1, 'months').format("YYYY-MM-DD"),
        fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    }))())
    const { data: pcsApiData } = useReadPurchaseOrderList({
        param: { ...searchParam, orderFlag: "N", userId: user?.userId ?? null },
        enabled: !isPcsDelivery && !isOrderRequest && !!user && !!user.userId
    })
    const { data: orderRequestApiData } = useReadPurchaseOrderList({
        param: { ...searchParam, orderFlag: "Y" },
        enabled: !isPcsDelivery && isOrderRequest
    })
    const { data: pcsDeliveryApiData } = useReadDeliveryList({
        param: { ...searchParam, userId: user?.userId ?? null },
        enabled: isPcsDelivery && !!user && !!user.userId
    })
    const pcs = isOrderRequest
        ? orderRequestApiData
        : isPcsDelivery
            ? pcsDeliveryApiData
            : pcsApiData;

    useEffect(() => {
        if (user?.userId) {
            setSearchParam(prev => ({ ...prev, userId: user?.userId }));
        }
    }, [user]);

    useEffect(() => {
        setSearchParam({ ...searchParam, pageNo: page })
    }, [page]);

    const menuTitleText = () => {
        if (isOrderRequest) {
            return "수주 요청 "
        } else if (isPcsDelivery) {
            return "납품 "
        } else {
            return "발주 "
        }
    }

    const urlText = () => {
        if (isOrderRequest) {
            return "order/orderRequest"
        } else if (isPcsDelivery) {
            return "purchase/delivery"
        } else {
            return "purchase/pcs"
        }
    }

    return <>
        <Filter searchParam={searchParam}
            setSearchParam={setSearchParam}
            menuTitleText={menuTitleText()}
            urlText={urlText()}
            isPcsDelivery={isPcsDelivery}
            isOrderRequest={isOrderRequest} />

        <List pcs={pcs ?? pcsListMapInit}
            searchParam={searchParam}
            menuTitleText={menuTitleText()}
            urlText={urlText()}
            isPcsDelivery={isPcsDelivery}
        />
    </>
}